export const loadState = () => {
  try {
    const serializedState = localStorage.getItem('state');
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveState = (state, sendBuffer) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('state', serializedState);

    if (sendBuffer.length > 0) {
      const serializedSendBuffer = JSON.stringify(sendBuffer);
      localStorage.setItem('sendBuffer', serializedSendBuffer);
    }
  } catch (err) {
    // Ignore write errors.
  }
};

export const getBufferData = () => {
  try {
    const localSendBuffer = localStorage.getItem('sendBuffer');
    if (localSendBuffer === null) {
      return undefined;
    }
    return JSON.parse(localSendBuffer);
  } catch (err) {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/localstorage.js